define('views/searchresults/index',[],function() {
	'use strict';

	window.assets = window.assets || {};

	require(['classes/productcollection'], function(collection) {
		window.assets.collection = collection;
		window.assets.collection.initiate(function() {
			console.log('collection initiated the old way');
		});

		require(['classes/product', 'postal'], function(Product, postal) {
			var products = document.querySelectorAll('#items .item'),
				i;

			for (i = 0; i < products.length; ++i) {
				var product = new Product({
					element: products[i]
				}).initiate();
			}
		});
	});

	require(['classes/recommendation', 'postal'], function(Recommendation, postal) {
		var recommendations = document.querySelectorAll('.recommendations'),
			i,
			recommendationsObjects = [];
		for (i = 0; i < recommendations.length; ++i) {
			recommendationsObjects.push(new Recommendation({
				element: recommendations[i],
				type: recommendations[i].getAttribute('data-recommendation-type')
			}).initiate());
		}

		var isRecommendationsReady = function() {
			for (i = 0; i < recommendations.length; ++i) {
				if (!recommendationsObjects[i].ready) {
					return false;
				}
			}

			clearInterval(waitForAllRecommendations);

			return true;
		};

		var waitForAllRecommendations = setInterval(function() {
			if (isRecommendationsReady()) {
				postal.channel('nosto').publish({
					topic: 'recommendation.all',
					data: function() {
						postal.channel('recommendation').publish({
							topic: 'render'
						});
					}
				});
			}
		}, 200);
	});

	require(['classes/lazyload'], function(LazyLoad) {
	    new LazyLoad().initiate();
	});
});
